import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=ed335dea&scoped=true&"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js&"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed335dea",
  null
  
)

export default component.exports